export type ChannelTalkSupportDocsLocale = 'ko' | 'en' | 'ja';

/**
 * Channel Talk의 ZEP 지원 문서는 한국어·영어·일본어만 제공한다.
 * 지원하지 않는 제품 로케일은 영어 문서로 연결한다.
 */
export function getChannelTalkSupportDocsLocale(
  locale: string | undefined,
): ChannelTalkSupportDocsLocale {
  if (locale === 'ko' || locale === 'ja') return locale;
  return 'en';
}

export function getChannelTalkSupportArticleUrl(
  locale: string | undefined,
  articleId: string,
): string {
  return `https://docs.channel.io/zep-support/${getChannelTalkSupportDocsLocale(
    locale,
  )}/articles/${articleId}`;
}

export function getChannelTalkGuideArticleUrl(
  locale: string | undefined,
  articleId: string,
): string {
  return `https://docs.channel.io/zep-guide/${getChannelTalkSupportDocsLocale(
    locale,
  )}/articles/${articleId}`;
}
